import { Component } from 'react';
import { Box, Image } from '@mantine/core';

export class Logo extends Component {
    render() {
        return (
            <Box
                mb={'1em'}
                w={'70%'}
                mx={'auto'}
                className={'Logo'}
            >
                <Image
                    src="/logoCompleto.svg"
                    alt=""
                />
            </Box>
        );
    }
}
